<template>
  <div style="margin-top:20px">
    <el-form
      ref="form"
      label-width="80px"
      :model="form"
    >
      <el-row>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item
              label="账户余额"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.balance"
                :disabled="true"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col
          :span="16"
          style="text-align: right;"
        >
          <el-button @click="funcFilter">
            查询
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <vxe-table
            ref="xTable"
            border
            show-footer
            highlight-hover-row
            row-id="id"
            :data="tableData"
            :sort-config="{ remote: true }"
            export-config
            show-overflow
            align="center"
            @sort-change="sortList"
          >
            <vxe-table-column>
              <vxe-table-column
                field="branchName"
                title="所属机构"
                width="160"
                sortable
              />
              <template v-slot:header>
                <el-input
                  v-model="listQuery.branchName"
                  placeholder="请输入所属机构编码"
                  clearable
                />
              </template>
            </vxe-table-column>
            <vxe-table-column>
              <vxe-table-column
                field="accountAmount"
                title="账户余额"
                width="100"
                sortable
              />
              <template v-slot:header>
                <el-input
                  v-model="listQuery.accountAmount"
                  placeholder="请输入平台账户余额"
                  clearable
                />
              </template>
            </vxe-table-column>
            <vxe-table-column>
              <vxe-table-column
                field="paidAmount"
                title="变动金额"
                width="100"
                sortable
              />
              <template v-slot:header>
                <el-input
                  v-model="listQuery.paidAmount"
                  placeholder="请输入变动金额"
                  clearable
                />
              </template>
            </vxe-table-column>
            <vxe-table-column>
              <vxe-table-column
                field="paidLineType"
                title="支付方式"
                width="100"
                sortable
              >
                <template v-slot="{ row }">
                  {{ paidLineType[row.paidLineType] }}
                </template>
              </vxe-table-column>
              <template v-slot:header>
                <el-select
                  v-model="listQuery.paidLineType"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(v,k) in paidLineType"
                    :key="k"
                    :label="v"
                    :value="k"
                  />
                </el-select>
              </template>
            </vxe-table-column>
            <vxe-table-column>
              <vxe-table-column
                field="paidItem"
                title="消费项目"
                width="100"
                sortable
              >
                <template v-slot="{ row }">
                  {{ paidItem[row.paidItem] }}
                </template>
              </vxe-table-column>
              <template v-slot:header>
                <el-select
                  v-model="listQuery.paidItem"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(v,k) in paidItem"
                    :key="k"
                    :label="v"
                    :value="k"
                  />
                </el-select>
              </template>
            </vxe-table-column>
            <vxe-table-column>
              <vxe-table-column
                field="paidFeeType"
                title="消费类型"
                width="100"
                sortable
              >
                <template v-slot="{ row }">
                  {{ paidFeeType[row.paidFeeType] }}
                </template>
              </vxe-table-column>
              <template v-slot:header>
                <el-select
                  v-model="listQuery.paidFeeType"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(v,k) in paidFeeType"
                    :key="k"
                    :label="v"
                    :value="k"
                  />
                </el-select>
              </template>
            </vxe-table-column>
            <vxe-table-column>
              <vxe-table-column
                field="createdByName"
                title="操作人"
                width="100"
                sortable
              />
              <template v-slot:header>
                <el-input
                  v-model="listQuery.createdByName"
                  placeholder="请输入操作人"
                  clearable
                />
              </template>
            </vxe-table-column>
            <vxe-table-column>
              <vxe-table-column
                field="gmtCreated"
                title="操作时间"
                min-width="400"
                sortable
              />
              <template v-slot:header>
                <el-date-picker
                  v-model="listQuery.gmtCreatedRange"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="optionsPicker"
                  :default-time="['00:00:00', '23:59:59']"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="value => changeDate(value, 'gmtCreated')"
                />
              </template>
            </vxe-table-column>
          </vxe-table>
          <vxe-pager
            :loading="loading"
            :page-sizes="Pagingconf"
            :current-page.sync="listQuery.pageNum"
            :page-size.sync="listQuery.pageSize"
            :total="listQuery.total"
            :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
            @page-change="handlePageChange"
          />
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import request from '@/utils/request'

  export default {
    name: 'PartyGroupDetail',
    data() {
      return {
        paidLineType:{'0':'在线支付','1':'现金支付'},
        paidItem:{'0':'充值','1':'北斗','2':'短信','3':'软件'},
        paidFeeType:{'0':'收入','1':'支出'},
        message: '',
        loading: false,
        tableData: [],
        form: {
          balance: '',
        },
        listQuery: {
          gmtCreatedRange: [],
          code: '',
          userCode: '',
          orderCode: '',
          paidLineType: '',
          paidItem: '',
          paidFeeType: '',
          paidAmount: '',
          paidRemark: '',
          accountAmount: '',
          createByBranch: '',
          pageNum: 1,
          pageSize: 20,
          sortField: '',
          sortType: '',
          total: 0
        },
      Pagingconf: [],
      }
    },
    methods: {
      getInfo(code,balance) {
        this.form.balance = balance;
        this.listQuery.createByBranch = code;
        this.findList();
      },
      findList() {
        this.loading = true
        request({
          url: '/ntocc-basic-api/paidRecord',
          method: 'get',
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records
          response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
          this.listQuery.total = response.data.total
          this.loading = false
        })
      },
    }
  }
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin-top: 50px;
  }
</style>
